import * as React from "react";
import LoadingIndicator from "../../LoadingIndicator/LoadingIndicator";

class LoadingButton extends React.Component {
	render() {
		const { label, showLoading } = this.props;

		return (
			showLoading
				? <button className="btn btn-primary" {...this.props} disabled><LoadingIndicator /></button>
				: <button className="btn btn-primary" {...this.props}>{label}</button>
		);
	}
}

export default LoadingButton;


// WEBPACK FOOTER //
// ./src/components/inputs/LoadingButton/LoadingButton.js